<header class="headerWrapper" [class.headerSticky]="isScrolleds" >
  <!-- *ngIf="isLoggedIn == true" -->
  <div class="container">
    <div class="row">
      <div class=" col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2">
        <a href="/welcome" class="logo">
          <img src="./images/logoheader.svg">
        </a>
      </div>
      <div class="col-3 colhidden col-sm-6 col-md-5 col-lg-8 col-xl-8">
        <ul class="welcomeList">
          <li>
            <img src="./images/up-pipe.svg" class="upPipe">
             <div class="upAnimation"><img src="./images/wheel.svg"   class="rotate"></div>
          </li>
          <li><h1>CNG Mitra Application </h1></li>
          <li>
            <img src="./images/down-pipe.svg"  class="downPipe">
            <div class="downAnimation"><img src="./images/watch.svg"  ></div>
          </li>
        </ul>
      </div>
      <div class="col-4 col-sm-2  col-md-3 col-lg-2 col-xl-2">
        <div class="dropdown text-end profile">
          <a href="#" class="d-block link-dark text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
            <img src="/images/userIcon.svg" alt="mdo" width="40" height="40" class="rounded-circle">
            <span>{{ empName ? empName.charAt(0).toUpperCase() + empName.slice(1).toLowerCase() : '' }}</span>       
  
          </a>
          <ul class="dropdown-menu">
            <!-- <li><a  href="#">New project...</a></li>
            <li><a href="#">Settings</a></li> -->
            <li><a href="javascript:void(0)">Profile</a></li>
            <!-- <li *ngIf="roleService.canModify('Forgot Password')"><a routerLink="/forget/password">Forgot Password</a></li> -->
            <!-- <li><a href="javascript:void(0)" (click)="forgotPassword()">Forgot Password</a></li> -->

            <li><a href="javascript:void(0)" (click)="logout()">Sign out</a></li>
          </ul>
        </div>
      </div>
      <div class="col-4 col-sm-2   col-md-2  col-lg-2 toggleBtnshowHide" >
        <button  #toggleDiv class="btn-toggle" id="myButton" (click)="toggleClass()" >
          <div class="line crossone"></div>
          <div class="line cross"></div>
          <div class="line close"></div>
        </button>
      </div>

    </div>
  </div>
</header>